import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GalleryFilesConfig } from './shared/gallery-files.config.service';
import { LocalDataSource } from 'ng2-smart-table';
import { FileUpload } from 'primeng/fileupload';
import { Logger } from '@app/core';

const log: Logger = new Logger('GalleryFilesComponent');

@Component({
  selector: 'iw-gallery-files',
  templateUrl: './gallery-files.component.html',
  styleUrls: ['./gallery-files.component.scss']
})
export class GalleryFilesComponent implements OnInit {
  // Contiene los archivos subidos
  uploadedFiles: any[] = [];
  // Configuracion de la tabla de visualizacion de los archivos subidos
  settings = {};
  // Datos para llenar la tabla
  source: LocalDataSource;
  // Referencia del componente fileupload
  @ViewChild('fileUpload') private fileUpload: FileUpload;

  constructor(private toastr: ToastrService) {}

  ngOnInit() {
    const docsC = new GalleryFilesConfig();
    this.settings = docsC.settings;
    this.source = new LocalDataSource(this.uploadedFiles);
  }

  /**
   * Emula el evento de subir el archivo al sistema guadando este en un arreglo
   * Agrega el arreglo a la tabla para que esta muestre el listado de documentos subidos
   *
   * @param {*} event
   * @memberof GalleryFilesComponent
   */
  onUpload(event: any) {
    log.debug(event);
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.source = new LocalDataSource(this.uploadedFiles);
    this.source.refresh();
    this.fileUpload.clear();
    this.toastr.success('Archivo subido correctamente.', 'Carga exitoxa.');
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/gallery-files/gallery-files.component.ts